import { render, staticRenderFns } from "./userCreateForm.vue?vue&type=template&id=d2633d72&scoped=true&"
import script from "./userCreateForm.vue?vue&type=script&lang=js&"
export * from "./userCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./userCreateForm.vue?vue&type=style&index=0&id=d2633d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2633d72",
  null
  
)

export default component.exports